<syslink-title text="User role"></syslink-title>

<syslink-grid
    [store]="userRolesService.store"
    [columns]="columns"
    (add)="addNew()"
    (doubleClick)="onDoubleClicked($event)"
    [storageKey]="storageKey"
    [filter]="filter"
></syslink-grid>